var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mail",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01302 7.78386C4.01302 7.04748 4.60997 6.45053 5.34635 6.45053H26.6667C27.403 6.45053 28 7.04748 28 7.78386V22.8828C28 24.3556 26.8061 25.5495 25.3333 25.5495H6.66667C5.19391 25.5495 4 24.3556 4 22.8828V8.21616C4 8.15266 4.00444 8.09021 4.01302 8.02908V7.78386ZM6.66667 10.7489V22.8828H25.3333V10.7493L18.8287 17.254C17.2666 18.8161 14.7339 18.8161 13.1718 17.254L6.66667 10.7489ZM8.7631 9.07407H23.2374L16.943 15.3684C16.4223 15.8891 15.5781 15.8891 15.0574 15.3684L8.7631 9.07407Z",
    fill: "#0083A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.e7188411.svg";
export { ForwardRef as ReactComponent };